import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { developerFactsSelector } from 'shared/selectors/specialPromosBlocks/developerFactsSelector';

import { Facts } from './Facts';

export const FactsContainer: FC = () => {
  const facts = useSelector(developerFactsSelector);

  if (!facts.length) {
    return null;
  }

  return <Facts facts={facts} isShort={facts.length < 4} />;
};
